// styles/buttonStyles.ts
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { type ButtonSize } from '@shared/models/components/ICoreButtonProps';
import { MixinFocusVisible } from '../structure/DefaultStyles';

export const buttonBaseStyles = css`
    text-align: center;
    border-radius: 0.5rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
    position: relative;
    padding: 0.5rem 1rem;
    gap: 0.5rem;
    text-underline-offset: 0.15rem;
    @media (prefers-reduced-motion: no-preference) {
        transition: all 0.1s ease-out;
        & * {
            transition: ease-out 0.1s;
        }
    }
    transform-origin: center;
    ${MixinFocusVisible}
`;

export const sizeStyles: Record<ButtonSize, SerializedStyles> = {
    small: css`
        font-size: 0.875rem;
        min-height: 2.5rem;
        padding: 0 0.875rem;
    `,
    medium: css`
        font-size: 1rem;
        line-height: 1.313rem;
        width: 240px;
        max-width: 100%;
        padding: 1rem;
    `,
    large: css`
        font-size: 1.25rem;
        line-height: 1.625rem;
        width: 100%;
        padding: 1.12rem;
    `,
    quick: css`
        font-size: 1rem;
        line-height: 1.313rem;
        padding: 0.625rem 0.875rem;
    `,
};

export const disabledButtonStyles = css`
    cursor: not-allowed;
    opacity: 0.9;
    color: #666;
    border-color: #666;
    &:hover {
        background: #ccc;
        color: #666;
    }
`;

export const TabButton = styled.button<{ isActive: boolean }>`
    padding: 8px 16px;
    border: none;
    background: ${(props) => (props.isActive ? props.theme.color.accent : props.theme.color.cardHover)};
    color: ${(props) => (props.isActive ? props.theme.color.background : props.theme.button.secondary.text)};
    cursor: pointer;
    border-radius: 50px;
    transition: all 0.2s ease;
    &:hover {
        background: ${(props) => props.theme.button.secondary.text};
        color: ${(props) => props.theme.color.background};
    }
    ${MixinFocusVisible}
`;
